import React from 'react';

import { SupportTicketFormBlock } from '../../types';
import { ResponseForm } from './support/ResponseForm';
import { TicketResultCard } from './support/ResponseFormResults';

/** Figma 6422:10265 (draft), 6459:16869 (processing), 6459:17172 (success), 6459:16542 (error). */
const SupportTicketForm: React.FC<{ block: SupportTicketFormBlock }> = ({ block }) => (
  <ResponseForm
    block={block}
    renderResult={(status, result, onAction) => (
      <TicketResultCard status={status} result={result} onAction={onAction} />
    )}
  />
);

export default SupportTicketForm;
